
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class MokYun extends Vue {
  @Prop() private msg!: string;
  public phoneShow = false;
  public tempWidth = 0;
  mounted() {
    this.tempWidth = document.body.clientWidth;
  }
  showScan() {
    this.phoneShow = !this.phoneShow;
  }
  // 获取
  get currentYear() {
    return new Date().getFullYear();
  }
  goMokyun() {
    window.open('https://mokyun.com', '_blank');
  }
  goBeiAn() {
    window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
  }
}
